var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForestTreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "-30.72 -30.72 125.44 125.44",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30.72,
    y: -30.72,
    width: 125.44,
    height: 125.44,
    rx: 45.1584,
    fill: "#024837",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5fde9",
    d: "M47.231,20.893C47.727,19.35,48,17.707,48,16c0-8.836-7.163-16-16-16S16,7.164,16,16 c0,1.707,0.273,3.35,0.769,4.893C10.505,23.062,6,28.998,6,36c0,8.836,7.163,16,16,16c3.465,0,6.661-1.117,9.28-2.99L23.27,41H19 c-0.553,0-1-0.447-1-1s0.447-1,1-1h4v-4c0-0.553,0.447-1,1-1s1,0.447,1,1v4.901l6,5.997V33.416l-3.7-3.7 c-0.391-0.391-0.348-0.98,0.044-1.372c0.391-0.391,0.934-0.48,1.324-0.09L32,31.586l3.29-3.29c0.391-0.391,1.038-0.405,1.429-0.015 s0.39,1.024-0.001,1.415L33,33.414v12.485l6-6.001V35c0-0.553,0.447-1,1-1s1,0.447,1,1v4h4c0.553,0,1,0.447,1,1s-0.447,1-1,1h-4.27 l-8.01,8.01C35.34,50.883,38.535,52,42,52c8.837,0,16-7.164,16-16C58,28.998,53.495,23.062,47.231,20.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5fde9",
    d: "M28,52.961V63c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1V52.961c-1.422-0.504-2.768-1.17-4-1.996 C30.768,51.791,29.422,52.457,28,52.961z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestTreeIcon);
export default __webpack_public_path__ + "static/media/forest-tree-icon.9a1c2412b926ff06af102701768f6568.svg";
export { ForwardRef as ReactComponent };